import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--space-100);
  padding: var(--space-200) var(--space-300);
  max-width: 250px;
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 150% */
  letter-spacing: var(--font-letter-spacing-loose);
`
